import { OrderTypeId, ResolutionId } from 'types/order'

export const ORDER_TYPES_TO_CHECK_DRIVER = [OrderTypeId.LOGISTIC_AND_DRIVER, OrderTypeId.DRIVER_AND_TS, OrderTypeId.DRIVER_FOR_LOADING]

export const ORDER_TYPES_TO_CHECK_DRIVER_LICENSE = [
  OrderTypeId.LOGISTIC_AND_DRIVER,
  OrderTypeId.DRIVER_AND_TS,
  OrderTypeId.DRIVER,
  OrderTypeId.DRIVER_DOC_CHECK,
  OrderTypeId.STATE_DRIVER,
  OrderTypeId.DRIVER_FOR_LOADING,
]

export const FINISH_POSITIVE_RESOLUTIONS = [ResolutionId.SHIPMENT_ALLOWED, ResolutionId.COOPERATION_AGREED]

export const FINISH_NEGATIVE_RESOLUTIONS = [ResolutionId.SHIPMENT_FORBIDDEN, ResolutionId.COOPERATION_FORBIDDEN]

export const FINISH_MIXED_RESOLUTIONS = [ResolutionId.LEGAL_ENTITY_PERMITTED_DRIVER_FORBIDDEN]

export const FINISH_RESOLUTIONS = [
  ResolutionId.SHIPMENT_ALLOWED,
  ResolutionId.LEGAL_ENTITY_PERMITTED_DRIVER_FORBIDDEN,
  ResolutionId.SHIPMENT_FORBIDDEN,
  ResolutionId.COOPERATION_AGREED,
  ResolutionId.COOPERATION_FORBIDDEN,
  ResolutionId.CHECK_CANCELED,
]

export const ORDER_TYPE_FOR_FAST_SUBMIT = [
  OrderTypeId.LOGISTIC_PAYER,
  OrderTypeId.STATE_DRIVER,
  OrderTypeId.EMPLOYEE,
  OrderTypeId.DRIVER_DOC_CHECK,
  OrderTypeId.COUNTERPARTY_BORROWER_AND_TS,
  OrderTypeId.PHONE_CHECK,
]

export const PHRASES_OF_RESOLUTION_FOR_DRIVER = [
  {
    label: 'Водитель отказался говорить',
    value: 'Водитель отказался говорить и отвечать на вопросы. Свяжитесь, пожалуйста, с водителем и убедите его пройти проверку.',
  },
  { label: 'Водитель не отвечает', value: 'Водитель не отвечает на звонок. Свяжитесь, пожалуйста, с водителем и попросите его принять звонок.' },
  { label: 'Негатив по водителю', value: 'Негатив по водителю.' },
  {
    label: 'Номер водителя - чужой',
    value: 'Запросите основной номер водителя. Этот, вероятно, используется другим человеком.',
  },
  {
    label: 'Номер водителя - доп номер',
    value: 'Запросите дополнительный номер телефона водителя.',
  },
  {
    label: 'Номер водителя - пустышка',
    value: 'Запросите основной номер водителя. По этому телефону не получается определить, принадлежит ли он водителю.',
  },
  {
    label: 'Номер водителя - недоступен/автоответчик',
    value: 'Запросите дополнительный номер водителя. Этот номер недоступен, срабатывает автоответчик или не обслуживается.',
  },
  {
    label: 'ВУ недействительно',
    value:
      'По данным сайта ГИБДД водительское удостоверение недействительно. Уточните, актуальное ли ВУ вы прислали? Пришлите новое ВУ, если предоставленное неактуально.',
  },
  {
    label: 'ВУ просрочено',
    value:
      'По данным сайта ГИБДД водительское удостоверение просрочено. Уточните, продлевалось ли ВУ или оно было заменено? Пришлите новое ВУ, если предоставленное неактуально.',
  },
  {
    label: 'Кредитный рейтинг отсутствует',
    value: 'Кредитный рейтинг отсутствует: в БКИ нет данных.',
  },
]

export const PHRASES_OF_RESOLUTION_FOR_LOGISTIC_PAYER = [
  {
    label: 'Основных средств 0...',
    value: 'Основных средств 0. Рекомендована работа по предоплате, либо с ограничением уровня дебиторской задолженности.',
  },
  {
    label: 'Номер контакта не верифицирован',
    value:
      'Не удалось подтвердить связь номера телефона контакта и контрагента. Уточните, пожалуйста, ведёте ли вы общение по данному номеру. Если нет — пришлите номер телефона, по которому ведёте общение.',
  },
  {
    label: 'Email не найден в ATI перевозчика',
    value:
      'Email не найден в ATI перевозчика. Возможно, в адресе указана ошибка. Укажите Email, по которому ведёте общение. Если вы действительно используете этот Email, сообщите нам — мы продолжим проверку.',
  },
]
